export default __webpack_public_path__ + "static/media/ug.f25d811b.svg";